'use client';

import { Button, TextPassage } from '@petsmart-ui/sparky';

import { trackFrequencyCalculatorClick } from '@libs/analytics';
import { getENV, logSentryError, logSentryEvent, useOptimizely } from '@libs/common-next';

import { useProduct } from '@/entities/product';
import { useFrequencyCalculatorDrawerStore } from '@/features/frequency-calculator-drawer';
import { SentryErrors, SentryEvents } from '@/shared/sentry';

export const FrequencyCalculatorCta = () => {
    const open = useFrequencyCalculatorDrawerStore(state => state.open);
    const { context } = useOptimizely();
    const { product } = useProduct();
    const locale = getENV('NEXT_PUBLIC_LOCALE');

    function handleClick() {
        trackFrequencyCalculatorClick();
        context?.trackEvent('_optex_US-CA_find-frequency-cta_FXE_pdp_s_1080');

        try {
            open();
            logSentryEvent('Opened frequency calculator', {
                sentryContext: SentryEvents.OPEN_FREQUENCY_CALCULATOR,
                tags: {
                    component: 'FrequencyCalculator',
                    severity: 'INFO',
                },
                extra: {
                    locale,
                    sku: product?.sku ?? 'unknown',
                },
            });
        } catch (error) {
            logSentryError(error, {
                ...SentryErrors.FrequencyCalculator.OpenFrequencyCalculatorFailed,
                extra: {
                    ...SentryErrors.FrequencyCalculator.OpenFrequencyCalculatorFailed.extra,
                    locale,
                    sku: product?.sku ?? 'unknown',
                },
            });
        }
    }

    return (
        <TextPassage size="sm">
            Need help?{' '}
            <Button
                type="button"
                variant="link"
                text="Find my frequency"
                data-testid="frequency-calculator-cta"
                onClick={handleClick}
            />
        </TextPassage>
    );
};
